
	
	<div id="divList" class="main-text-area" #chatlist>
	
	    <ul class="list-group">
	      <app-message-item *ngFor="let msg of messages" [message]="msg"></app-message-item>
	    </ul>
	</div>
 
